import React from 'react';
import maleimg from '../style/icons/male.svg';
import femaleimg from '../style/icons/female.svg';
import editicon from '../style/icons/edit.svg';
import speechicon from '../style/icons/speech-bubble.svg';
// import phoneicon from '../style/icons/phone.svg';
import '../style/css/client.css'

const Client = () => {
    return (
        <div className={'client-container'}>
            <img src={maleimg} className={'client-img'}/>
            <div className={'client-full-name'}>יובל בן שאול</div>
            <div className={'client-phone-number'}>050-9111111</div>
            <div className={'client-btn-container'}>
                <img src={editicon} className={'edit-icon'}/>
                <img src={speechicon} className={'speech-icon'}/>
                {/*<img src={phoneicon} className={'phone-icon'}/>*/}

            </div>
        </div>
    );
};

export default Client;